export default __webpack_public_path__ + "static/media/G0000.de2d9fcf.png";